import React from 'react';
import IconBase from './IconBase';

const NoteAddIcon = props => {
    return (
        <IconBase viewBox={'0 0 40 40'} {...props}>
            <path d="M30.3,17.7c-0.1,0-0.2,0-0.3,0v15.3H9.7V9.3h3.4v1.3c0,0.7,0.6,1.3,1.3,1.3c0.7,0,1.3-0.6,1.3-1.3V9.3h2.9v1.3
	c0,0.7,0.6,1.3,1.3,1.3c0.7,0,1.3-0.6,1.3-1.3V9.3h1.4c0.1-0.9,0.3-1.7,0.6-2.5h-2V5.5c0-0.7-0.6-1.3-1.3-1.3
	c-0.7,0-1.3,0.6-1.3,1.3v1.3h-2.9V5.5c0-0.7-0.6-1.3-1.3-1.3c-0.7,0-1.3,0.6-1.3,1.3v1.3H9.7C9.1,6.8,8.5,7,8,7.5
	C7.5,8,7.2,8.6,7.2,9.3v23.6c0,0.7,0.3,1.3,0.8,1.8c0.5,0.5,1.1,0.8,1.8,0.8H30c0.7,0,1.3-0.3,1.8-0.8c0.5-0.5,0.8-1.1,0.8-1.8V17.3
	C31.8,17.5,31.1,17.7,30.3,17.7z"/>
            <polygon points="35.3,8.5 31.7,8.5 31.7,4.9 28.9,4.9 28.9,8.5 25.3,8.5 25.3,11.2 28.9,11.2 28.9,14.9 31.7,14.9 31.7,11.2
	35.3,11.2 "/>
            <rect x="14.1" y="21.7" width="11.4" height="2.4"/>
            <rect x="14.1" y="16" width="11.4" height="2.4"/>
            <rect x="14.1" y="27.3" width="11.4" height="2.4"/>
        </IconBase>
    )
}

export default NoteAddIcon;